export const ultimasNoticias = [
    // {
    //     "imagen" : "image/transparencia2026.webp",
    //     "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/contraloriat/dir1/Documentos/TRANSP%20EN%20CORTO_CONVOCATORIA_2026.pdf",
    //     "titulo" : "Concurso Nacional Transparencia en Corto 2025",
    //     "fecha" : ""
    // },
    // {
    //     "imagen" : "image/dryc2025.jpg",
    //     "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/obrasp/doc/interes/ConvocaDRYC.pdf",
    //     "titulo" : "Convocatoria para obtener el Registro o Refrendo de Director Responsable y Corresponsable (DRyC)",
    //     "fecha" : "11 de marzo de 2025 al 10 de julio de 2025"
    // },
    // {
    //     "imagen" : "image/construyeTuCamino-1.jpg",
    //     "url" : "/ConstruyeTuCamino",
    //     // "titulo" : "Construye Tu Camino",
    //     // "fecha" : ""
    // },
    {
        "imagen" : "image/vaguada.jpg",
        "url" : "https://sipdusreconstruccion.hidalgo.gob.mx/",
        "titulo" : "Reconstrucción Vaguada Monzónica",
        "fecha" : ""
    },
    {
        "imagen" : "image/listado_vaguada.jpg",
        "url" : "/Reconstruccion2025",
        "titulo" : "listado de obras de reconstrucción de vaguada monzónica",
        "fecha" : ""
    },
    // {
    //     "imagen" : "image/banner_programa_ordenacion.jpeg",
    //     "url" : "https://s-infraestructura.hidalgo.gob.mx/image/actualizacion_programa_ordenacion.jpeg",
    //     "titulo" : "Reconstruccion2025 que se estan ejecutando en los 84 municipios del estado.",
    //     "fecha" : ""
    // },
    {
        "imagen" : "image/obras.jpg",
        "url" : "https://innovacion-sopot.hidalgo.gob.mx/view/public/?controller=sopot_works&view=works_by_year",
        "titulo" : "Reconstruccion2025 que se estan ejecutando en los 84 municipios del estado.",
        "fecha" : ""
    },
]